/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../../graphql/src/lib/graphql/generated/types'

const defaultOptions = {} as const
export type BackofficeUserManagementLogoutBackofficeUserMutationVariables =
  Types.Exact<{
    input: Types.BackofficeUserManagementLogoutBackofficeUserInput
  }>

export type BackofficeUserManagementLogoutBackofficeUserMutation = {
  __typename?: 'Mutation'
  backofficeUserManagementLogoutBackofficeUser: string
}

export const BackofficeUserManagementLogoutBackofficeUserDocument = gql`
    mutation BackofficeUserManagementLogoutBackofficeUser($input: BackofficeUserManagementLogoutBackofficeUserInput!) {
  backofficeUserManagementLogoutBackofficeUser(input: $input)
}
    `
export type BackofficeUserManagementLogoutBackofficeUserMutationFn =
  Apollo.MutationFunction<
    BackofficeUserManagementLogoutBackofficeUserMutation,
    BackofficeUserManagementLogoutBackofficeUserMutationVariables
  >

/**
 * __useBackofficeUserManagementLogoutBackofficeUserMutation__
 *
 * To run a mutation, you first call `useBackofficeUserManagementLogoutBackofficeUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBackofficeUserManagementLogoutBackofficeUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [backofficeUserManagementLogoutBackofficeUserMutation, { data, loading, error }] = useBackofficeUserManagementLogoutBackofficeUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBackofficeUserManagementLogoutBackofficeUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    BackofficeUserManagementLogoutBackofficeUserMutation,
    BackofficeUserManagementLogoutBackofficeUserMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    BackofficeUserManagementLogoutBackofficeUserMutation,
    BackofficeUserManagementLogoutBackofficeUserMutationVariables
  >(BackofficeUserManagementLogoutBackofficeUserDocument, options)
}
export type BackofficeUserManagementLogoutBackofficeUserMutationHookResult =
  ReturnType<typeof useBackofficeUserManagementLogoutBackofficeUserMutation>
export type BackofficeUserManagementLogoutBackofficeUserMutationResult =
  Apollo.MutationResult<BackofficeUserManagementLogoutBackofficeUserMutation>
export type BackofficeUserManagementLogoutBackofficeUserMutationOptions =
  Apollo.BaseMutationOptions<
    BackofficeUserManagementLogoutBackofficeUserMutation,
    BackofficeUserManagementLogoutBackofficeUserMutationVariables
  >
